











































































































































import Vue, { PropType } from "vue";
import VueClipboard from "vue-clipboard2";
import clone from "lodash/cloneDeep";
import InputText from "@/components/atoms/InputText.vue";
import DeleteIcon from "@/components/atoms/DeleteIcon.vue";
import CheckboxIcon from "@/components/atoms/CheckboxIcon.vue";
import WarningIcon from "@/components/atoms/WarningIcon.vue";
import { Manuscript, SharedLink, Plan } from "@/lib/models";
import { SharedManuscriptStorage } from "@/lib/storages";
import { compareAsc } from "date-fns";
// NOTE: 機能紹介GIFを修正するため一時的にコメントアウト
// import { Dialog } from "@/lib/utils";
// import PremiumFeatureDialog, { PremiumFeatureDialogProps } from "@/components/ui/PremiumFeatureDialog.vue";
// import { downloadPublicImage } from "@/lib/s3";

Vue.use(VueClipboard);

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    InputText,
    DeleteIcon,
    CheckboxIcon,
    WarningIcon,
  },
  props: {
    novelId: {
      type: String as PropType<string>,
    },
  },
  data() {
    return {
      selected: null,
      name: "",
      copied: false,
      saved: false,
      deleted: false,
      isDeleting: false,
      isStopping: false,
    };
  },
  destroyed() {
    this.closePublishSharedLink();
  },
  methods: {
    select(item) {
      this.selected = clone(item);
    },
    onClickManuscript(manuscript) {
      if (this.selected.manuscriptKeys.includes(manuscript.key)) {
        this.selected.manuscriptKeys = this.selected.manuscriptKeys.filter((x) => x !== manuscript.key);
      } else {
        this.selected.manuscriptKeys.push(manuscript.key);
      }
    },
    closePublishSharedLink() {
      this.$store.dispatch("sharedLinkModule/closePublishSharedLink");
    },
    async createSharedLink() {
      if (this.isFree && this.sharedLinkListBelongOwner.length >= 3) {
        // NOTE: 機能紹介GIFを修正するため一時的にコメントアウト
        // const premiumFeatureDialog = new Dialog(PremiumFeatureDialog);
        // const data: PremiumFeatureDialogProps = {
        //   title: "共有リンクの無制限作成はプレミアム機能です",
        //   text: "原稿の共有リンクは、アカウントごとに3つまで無料で作成が可能となっております。プレミアム会員になると、共有リンクが無制限で作成することができますので、多くの方に作品を共有する場合はぜひご利用いただけますと幸いです。",
        //   image: (await downloadPublicImage("shared/images/gif/manuscript_share.gif")) as string,
        // };
        // premiumFeatureDialog.show(data);

        this.$router.push({ name: "subscriptionAnnounce", query: { from: "createSharedLink" } });

        return;
      }

      const { novelId } = this;
      this.$store.dispatch("sharedLinkModule/createSharedLink", {
        novelId,
        name: "",
        manuscriptKeys: [],
        callback: () => {
          this.selected = clone(this.createdSharedLink);
          this.$store.dispatch("sharedLinkModule/initializeCreatedSharedLink");
          this.$store.dispatch("sharedLinkModule/initializeSharedLinkListBelongOwner");
        },
      });
    },
    isChecked(manuscript) {
      return this.selected.manuscriptKeys.includes(manuscript.key);
    },
    onCopy() {
      this.copied = true;
      setTimeout(() => (this.copied = false), 2000);
    },
    save() {
      const { sharedLinkId, novelId, name, manuscriptKeys, enabled } = this.selected as SharedLink;
      this.$store.dispatch("sharedLinkModule/updateSharedLink", {
        sharedLinkId,
        novelId,
        name,
        manuscriptKeys,
        enabled,
        callback: async () => {
          /** 共有対象の原稿を他人が閲覧可能なディレクトリに複製する */
          if (manuscriptKeys) {
            const sharedManuscriptStorage = new SharedManuscriptStorage();
            const promiseArray = manuscriptKeys.map(
              async (key) => await sharedManuscriptStorage.duplicateFile(novelId, key)
            );
            await Promise.all(promiseArray);
          }

          this.saved = true;
          setTimeout(() => (this.saved = false), 2000);
        },
      });
    },
    onClickDelete() {
      this.isDeleting = true;
    },
    cancelDelete() {
      this.isDeleting = false;
    },
    onClickStop() {
      this.isStopping = true;
    },
    cancelStop() {
      this.isStopping = false;
    },
    deleteSharedLink() {
      const { sharedLinkId, novelId } = this.selected as SharedLink;
      this.$store.dispatch("sharedLinkModule/deleteSharedLink", {
        sharedLinkId,
        novelId,
        callback: () => {
          this.$store.dispatch("sharedLinkModule/initializeSharedLinkListBelongOwner");
          this.selected = null;
          this.isDeleting = false;
          this.deleted = true;
          setTimeout(() => (this.deleted = false), 2000);
        },
      });
    },
    stopSharedLink() {
      const { sharedLinkId, novelId, name, manuscriptKeys } = this.selected as SharedLink;
      this.$store.dispatch("sharedLinkModule/updateSharedLink", {
        sharedLinkId,
        novelId,
        name,
        manuscriptKeys,
        enabled: false,
        callback: () => {
          this.selected.enabled = false;
          this.isStopping = false;
        },
      });
    },
    resumeSharedLink() {
      const { sharedLinkId, novelId, name, manuscriptKeys } = this.selected as SharedLink;
      this.$store.dispatch("sharedLinkModule/updateSharedLink", {
        sharedLinkId,
        novelId,
        name,
        manuscriptKeys,
        enabled: true,
        callback: () => {
          this.selected.enabled = true;
        },
      });
    },
  },
  computed: {
    sharedLinkList() {
      const sharedLinkList = this.$store.getters["sharedLinkModule/sharedLinkList"] as SharedLink[];
      const enabledList = sharedLinkList
        .filter((sharedLink) => sharedLink.enabled)
        .sort((x, y) => compareAsc(x.createdAt!, y.createdAt!));
      const disabledList = sharedLinkList
        .filter((sharedLink) => !sharedLink.enabled)
        .sort((x, y) => compareAsc(x.createdAt!, y.createdAt!));
      return enabledList.concat(disabledList);
    },
    sharedLinkListBelongOwner() {
      return this.$store.getters["sharedLinkModule/sharedLinkListBelongOwner"] as SharedLink[];
    },
    createdSharedLink() {
      return this.$store.getters["sharedLinkModule/createdSharedLink"];
    },
    manuscriptList() {
      return this.$store.getters["manuscriptModule/manuscriptList"];
    },
    sharedLinkPath() {
      return (item) => {
        if (!item) return;

        const { protocol, host } = location;
        const { sharedLinkId, novelId } = item;

        return `${protocol}//${host}/share/${sharedLinkId}/${novelId}/manuscript`;
      };
    },
    resolveSharedLinkPath() {
      return (item) => {
        const { sharedLinkId, novelId } = item;

        return `/share/${sharedLinkId}/${novelId}/manuscript`;
      };
    },
    plan() {
      return this.$store.getters["userModule/plan"] as Plan;
    },
    isFree() {
      return this.plan === Plan.free;
    },
  },
});

interface Data {
  selected: SharedLink | null;
  name: string;
  copied: boolean;
  saved: boolean;
  deleted: boolean;
  isDeleting: boolean;
  isStopping: boolean;
}

interface Props {
  novelId: string;
}

interface Computed {
  sharedLinkList: SharedLink[];
  sharedLinkListBelongOwner: SharedLink[];
  createdSharedLink: SharedLink;
  manuscriptList: Manuscript[];
  sharedLinkPath: (item: SharedLink) => string | undefined;
  resolveSharedLinkPath: (item: SharedLink) => string;
  plan: Plan;
  isFree: boolean;
}

interface Methods {
  select: (item: SharedLink) => void;
  onClickManuscript: (manuscript: Manuscript) => void;
  closePublishSharedLink: () => void;
  createSharedLink: () => void;
  isChecked: (manuscript: Manuscript) => boolean;
  onCopy: () => void;
  save: () => void;
  onClickDelete: () => void;
  cancelDelete: () => void;
  onClickStop: () => void;
  cancelStop: () => void;
  deleteSharedLink: () => void;
  stopSharedLink: () => void;
  resumeSharedLink: () => void;
}
